export const locale = {
    lang: 'fr',
    data: {
        BACKGROUND_PANEL_CHOOSE:'Changer le fond d\'écran',
    }
};
